import React from 'react'
import { useLocation } from 'react-router-dom'

import styles from './ClinicalProcessesController.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useFetchList } from 'store'

const sortOptionsFunc = (i18n) => [
	{
		value: 'date,desc',
		text: i18n`Date, desc.`,
	},
	{
		value: 'date,asc',
		text: i18n`Date, asc.`,
	},
]

const ClinicalProcessesFilters = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)

	const sortOptions = sortOptionsFunc(i18n)

	const selectedSort = queryParams.sort
		? sortOptions.find(
				({ value }) =>
					queryParams.sort.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const {
		contents: [insuranceCompanies, serviceProviders, bodyParts],
	} = useFetchList(
		[
			'/metadata/insurance_companies',
			'/metadata/provider_entities',
			'/metadata/body_parts',
		],
		[
			(json) => {
				return {
					value: json.id.toString(),
					text: json.shortName,
				}
			},
			(json) => {
				return {
					value: json.id.toString(),
					text: json.name,
				}
			},
			(json) => {
				return {
					value: json.id.toString(),
					text: json.name,
				}
			},
		],
		60000 * 60 // One hour
	)

	const insuranceCompaniesFilters = Array.isArray(insuranceCompanies)
		? [
				{
					value: '',
					text: i18n`Any`,
				},
				...insuranceCompanies,
		  ]
		: []

	const selectedCompany = queryParams.company
		? insuranceCompaniesFilters.find(
				({ value }) =>
					queryParams.company.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const providerFilters = Array.isArray(serviceProviders)
		? [
				{
					value: '',
					text: i18n`Any`,
				},
				...serviceProviders,
		  ]
		: []

	const selectedProvider = queryParams.providerEntity
		? providerFilters.find(
				({ value }) =>
					queryParams.providerEntity.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const bodyPartFilters = Array.isArray(bodyParts)
		? [
				{
					value: '',
					text: i18n`Any`,
				},
				...bodyParts,
		  ]
		: []

	const selectedBodyPart = queryParams.bodyPart
		? bodyPartFilters.find(
				({ value }) =>
					queryParams.bodyPart.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	return (
		<HStack
			className={styles['header-options']}
			align='center'
			justify='space-between'
			wrap='wrap'
			gap='xsmall'
			flex={[
				[1, 1],
				[1, 1],
			]}
		>
			<HStack
				align='center'
				justify='flex-start'
				wrap='nowrap'
				gap='xsmall'
			>
				<VStack>
					<small>
						<strong>{i18n`Processes`}</strong>
					</small>
					<small className='ellipsis'>{i18n`Order by`}:</small>
				</VStack>
				<div>
					<Dropdown
						className={styles['options-entry']}
						name='sort'
						value={
							selectedSort
								? selectedSort.value
								: sortOptions[0].value
						}
						options={sortOptions}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								sort: e.target.value,
							})
						}}
					/>
				</div>
			</HStack>
			<HStack
				align='center'
				justify='flex-end'
				wrap='nowrap'
				gap='xsmall'
				columns={['auto', 'auto', 'auto']}
				flex={[
					[1, 1],
					[1, 1],
					[1, 1],
				]}
			>
				{insuranceCompaniesFilters.length ? (
					<Dropdown
						className={styles['options-entry']}
						name='company'
						placeholder={i18n`Ins. Company`}
						searchable
						value={
							selectedCompany
								? selectedCompany.value
								: insuranceCompaniesFilters[0].value
						}
						options={insuranceCompaniesFilters}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								company: e.target.value,
							})
						}}
					/>
				) : null}
				{providerFilters.length ? (
					<Dropdown
						className={styles['options-entry']}
						name='company'
						placeholder={i18n`Srv. Provider`}
						searchable
						value={
							selectedProvider
								? selectedProvider.value
								: providerFilters[0].value
						}
						options={providerFilters}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								providerEntity: e.target.value,
							})
						}}
					/>
				) : null}
				{bodyPartFilters.length ? (
					<Dropdown
						className={styles['options-entry']}
						name='company'
						placeholder={i18n`Body part`}
						searchable
						value={
							selectedBodyPart
								? selectedBodyPart.value
								: bodyPartFilters[0].value
						}
						options={bodyPartFilters}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								bodyPart: e.target.value,
							})
						}}
					/>
				) : null}
			</HStack>
		</HStack>
	)
}

export default ClinicalProcessesFilters
